import {
  Box,
  Button,
  Card,
  CardContent,
  Fade,
  Typography,
} from "@mui/material";
import AppButton from "../../components/button/AppButton";
import AppTextInput from "../../components/inputs/AppTextInput";
import { AppColors } from "../../constants/AppColors";
import { useResetPasswordScreen } from "./hooks/useResetPasswordScreen";

const ResetPasswordScreen = () => {
  const vm = useResetPasswordScreen();

  return (
    <Box
      sx={{
        minHeight: "100vh",
        bgcolor: AppColors.background,
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        p: 2,
      }}
    >
      <Fade in timeout={350}>
        <Card sx={{ width: "100%", maxWidth: 430, borderRadius: "24px" }}>
          <CardContent sx={{ p: 3 }}>
            <Box
              sx={{
                width: 56,
                height: 56,
                borderRadius: "18px",
                bgcolor: AppColors.primary,
                color: AppColors.textOnPrimary,
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
                mb: 2,
                fontWeight: 900,
                fontSize: 24,
              }}
            >
              RP
            </Box>

            <Typography variant="h4" sx={{ fontWeight: 900, mb: 1 }}>
              {vm.t("auth.resetPassword")}
            </Typography>

            <Typography color="text.secondary" sx={{ mb: 3 }}>
              {vm.t("auth.resetPasswordSubtitle")}
            </Typography>

            {!vm.hasValidLink ? (
              <Typography color="error" sx={{ fontWeight: 700, mb: 1.5 }}>
                {vm.t("auth.invalidResetLink")}
              </Typography>
            ) : null}

            {vm.error ? (
              <Typography color="error" sx={{ fontWeight: 700, mb: 1.5 }}>
                {vm.error}
              </Typography>
            ) : null}

            {vm.successMessage ? (
              <Typography
                color="success.main"
                sx={{ fontWeight: 700, mb: 1.5 }}
              >
                {vm.successMessage}
              </Typography>
            ) : null}

            <Box component="form" onSubmit={vm.handleSubmit}>
              <AppTextInput
                label={vm.t("auth.email")}
                value={vm.email}
                onChange={(event) => vm.setEmail(event.target.value)}
                error={Boolean(vm.getFieldError("email"))}
                helperText={vm.getFieldError("email")}
                autoComplete="email"
                disabled={!vm.hasValidLink || vm.loading}
              />

              <AppTextInput
                label={vm.t("auth.newPassword")}
                value={vm.password}
                onChange={(event) => vm.setPassword(event.target.value)}
                type="password"
                error={Boolean(vm.getFieldError("password"))}
                helperText={vm.getFieldError("password")}
                autoComplete="new-password"
                disabled={!vm.hasValidLink || vm.loading}
              />

              <AppTextInput
                label={vm.t("auth.confirmPassword")}
                value={vm.passwordConfirmation}
                onChange={(event) =>
                  vm.setPasswordConfirmation(event.target.value)
                }
                type="password"
                error={Boolean(vm.getFieldError("password_confirmation"))}
                helperText={vm.getFieldError("password_confirmation")}
                autoComplete="new-password"
                disabled={!vm.hasValidLink || vm.loading}
              />

              <Box sx={{ mt: 2 }}>
                <AppButton
                  title={vm.t("auth.resetPassword")}
                  type="submit"
                  loading={vm.loading}
                  disabled={!vm.hasValidLink || Boolean(vm.successMessage)}
                />
              </Box>
            </Box>

            <Box sx={{ mt: 2, textAlign: "center" }}>
              <Button
                variant="text"
                onClick={vm.goToLogin}
                disabled={vm.loading}
              >
                {vm.t("auth.backToLogin")}
              </Button>
            </Box>
          </CardContent>
        </Card>
      </Fade>
    </Box>
  );
};

export default ResetPasswordScreen;
